import { render, staticRenderFns } from "./examInfo.vue?vue&type=template&id=08b555b0&scoped=true&"
import script from "./examInfo.vue?vue&type=script&lang=js&"
export * from "./examInfo.vue?vue&type=script&lang=js&"
import style0 from "./examInfo.vue?vue&type=style&index=0&id=08b555b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b555b0",
  null
  
)

export default component.exports